/* eslint-disable quote-props */
export default {
   /* eslint-disable key-spacing */
   '015': 'Keuangan',
   '018': 'Pertanian',
   '019': 'Perindustrian',
   '020': 'Energi dan Sumber Daya Mineral',
   '022': 'Perhubungan',
   '023': 'Pendidikan dan Kebudayaan',
   '024': 'Kesehatan',
   '025': 'Agama',
   '026': 'Ketenagakerjaan',
   '028': 'Pendidikan Tinggi, Sains dan Teknologi',
   '029': 'Lingkungan Hidup/Pengendalian Lingkungan Hidup',
   '032': 'Kelautan dan Perikanan',
   '033': 'Pekerjaan Umum',
   '040': 'Pariwisata',
   '042': 'Riset Teknologi dan Pendidikan Tinggi',
   '043': 'Kehutanan',
   '044': 'Koperasi dan usaha Kecil dan Menengah',
   '046': 'Ekonomi Kreatif/Badan Ekonomi Kreatif',
   '049': 'Kebudayaan',
   '059': 'Komunikasi dan Digital',
   '060': 'Kepolisian',
   '063': 'Obat dan Makanan',
   '065': 'Badan Koordinasi Penanaman Modal',
   '080': 'Ketenaganukliran',
   '083': 'Badan Informasi Geospasial',
   '090': 'Perdagangan',
   '091': 'Permuhan dan Permukiman',
   '104': 'Badan Nasional Penempatan dan Perlindungan Tenaga Kerja Indonesia',
   /* eslint-enable key-spacing */
}

// const sektorList = [
//    { kode: "015", nama: "Keuangan" },
//    { kode: "018", nama: "Pertanian" },
//    { kode: "019", nama: "Perindustrian" },
//    { kode: "020", nama: "Energi dan Sumber Daya Mineral" },
//    { kode: "022", nama: "Perhubungan" },
//    { kode: "023", nama: "Pendidikan dan Kebudayaan" },
//    { kode: "024", nama: "Kesehatan" },
//    { kode: "025", nama: "Agama" },
//    { kode: "026", nama: "Ketenagakerjaan" },
//    { kode: "028", nama: "Pendidikan Tinggi, Sains dan Teknologi" },
//    {
//       kode: "029",
//       nama: "Lingkungan Hidup/Pengendalian Lingkungan Hidup",
//    },
//    { kode: "032", nama: "Kelautan dan Perikanan" },
//    { kode: "033", nama: "Pekerjaan Umum" },
//    { kode: "040", nama: "Pariwisata" },
//    { kode: "042", nama: "Riset Teknologi dan Pendidikan Tinggi" },
//    { kode: "043", nama: "Kehutanan" },
//    { kode: "044", nama: "Koperasi dan Usaha Kecil dan Menengah" },
//    { kode: "046", nama: "Ekonomi Kreatif/Badan Ekonomi Kreatif" },
//    { kode: "049", nama: "Kebudayaan" },
//    { kode: "059", nama: "Komunikasi dan Digital" },
//    { kode: "060", nama: "Kepolisian" },
//    { kode: "063", nama: "Obat dan Makanan" },
//    { kode: "065", nama: "Badan Koordinasi Penanaman Modal" },
//    { kode: "080", nama: "Ketenaganukliran" },
//    { kode: "083", nama: "Badan Informasi Geospasial" },
//    { kode: "085", nama: "Ketenaganukliran" },
//    { kode: "090", nama: "Perdagangan" },
//    { kode: "091", nama: "Perumahan dan Permukiman" },
//    {
//       kode: "104",
//       nama: "Badan Nasional Penempatan dan Perlindungan Tenaga Kerja Indonesia",
//    },
// ];
